import { Button, Form, FormInstance, Input, Row } from "antd";
import { useCallback } from "react";
import { useSendReport } from "../hooks/useSendReport";
import { Rule } from "antd/es/form";
import { useReportRules } from "../hooks/useReportRules";

const { TextArea } = Input;

type FormContainerProps = {
  conversationId: string;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const FormContainer = ({
  conversationId,
  setIsOpen,
}: FormContainerProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const onClose = useCallback(() => setIsOpen(false), [setIsOpen]);

  const { isLoading, onReport } = useSendReport(conversationId, form, onClose);

  const rules: Rule[] = useReportRules();

  return (
    <Form form={form} layout="vertical" requiredMark={false}>
      <p className="mb-4 mt-0 text pt-4">
        The message will be sent to Administrator only.
      </p>
      <span className="text-md title">Provide the details:</span>
      <Form.Item name="reportMessage" label="" className="mb-5" rules={rules}>
        <TextArea
          className="report-msg"
          rows={2}
          placeholder="e.g. inappropriate communication, harassment, etc."
        />
      </Form.Item>
      <Row className="justify-end align-center pt-6">
        <Button
          type="primary"
          className="mr-2"
          size="large"
          shape="round"
          disabled={isLoading}
          loading={isLoading}
          onClick={onReport}
        >
          Report
        </Button>
        <Button
          size="large"
          shape="round"
          disabled={isLoading}
          onClick={onClose}
        >
          Close
        </Button>
      </Row>
    </Form>
  );
};
